var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRabbywallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M29.514 17.732C30.6 15.298 25.23 8.496 20.1 5.662c-3.233-2.196-6.603-1.894-7.285-.93-1.498 2.115 4.959 3.908 9.277 6-.928.404-1.803 1.13-2.317 2.058-1.61-1.763-5.144-3.282-9.29-2.058-2.793.824-5.115 2.767-6.013 5.702A1.762 1.762 0 0 0 2 18.047c0 .975.787 1.765 1.759 1.765.18 0 .743-.12.743-.12l8.995.065c-3.597 5.726-6.44 6.563-6.44 7.555s2.72.723 3.741.354c4.89-1.77 10.142-7.288 11.043-8.876 3.784.474 6.965.53 7.673-1.058Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    d: "M22.091 10.732c.2-.08.168-.376.113-.609-.126-.535-2.305-2.694-4.352-3.662-2.789-1.318-4.843-1.25-5.146-.642.568 1.168 3.202 2.265 5.952 3.41 1.174.49 2.369.987 3.433 1.503Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    d: "M18.552 22.49a16.498 16.498 0 0 0-1.925-.595c.772-1.386.934-3.439.205-4.737-1.024-1.821-2.309-2.79-5.295-2.79-1.642 0-6.064.554-6.142 4.258-.009.389 0 .745.028 1.072l8.074.059c-1.089 1.733-2.108 3.018-3 3.995 1.07.275 1.955.507 2.767.719.77.201 1.476.386 2.214.575a33.648 33.648 0 0 0 3.074-2.556Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M4.364 19.318c.33 2.813 1.924 3.916 5.18 4.242 3.256.326 5.124.107 7.61.334 2.078.19 3.932 1.252 4.62.885.62-.33.273-1.524-.556-2.29-1.073-.992-2.56-1.681-5.175-1.926.521-1.432.375-3.44-.434-4.532-1.17-1.58-3.33-2.293-6.065-1.981-2.857.326-5.594 1.737-5.18 5.268Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 10.16,
    x2: 29.29,
    y1: 15.576,
    y2: 20.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8697FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 26.06,
    x2: 12.217,
    y1: 15.211,
    y2: 1.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8697FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5156D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 18.936,
    x2: 5.661,
    y1: 22.973,
    y2: 15.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#465EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8697FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 11.301,
    x2: 20.296,
    y1: 15.433,
    y2: 26.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8898FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#6277F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbywallet);
export default __webpack_public_path__ + "static/media/rabbywallet.7ef93bd6b8c41463b7d79f35bb970791.svg";
export { ForwardRef as ReactComponent };